import { render } from "./AvatarBrowse.vue?vue&type=template&id=3aee26ce"
import script from "./AvatarBrowse.vue?vue&type=script&lang=ts"
export * from "./AvatarBrowse.vue?vue&type=script&lang=ts"
script.render = render

export default script